var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"reset-btn button button_link button_no-border button_transparent",on:{"click":_vm.showComplaintMessage}},[_vm._v("Я обнаружил несанкционированный объект размещения отходов")])
}
var staticRenderFns = []

export { render, staticRenderFns }